// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Utils = require("../../../utils/Utils.bs.js");
var React = require("react");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var ConversationAlertProvider = require("./ConversationAlertProvider").default;

function messageFromJs(messageJs) {
  var match = messageJs.message_type;
  switch (match) {
    case "initial" :
        return {
                id: messageJs.id,
                messageType: "INITIAL"
              };
    case "reply" :
        return {
                id: messageJs.id,
                messageType: "REPLY"
              };
    default:
      return ;
  }
}

function conversationFromJs(conversationJs) {
  var message = messageFromJs(conversationJs.message);
  if (message !== undefined) {
    return {
            id: conversationJs.id,
            message: message
          };
  }
  
}

function alertFromJs(alertJs) {
  var match = alertJs.alertStatus;
  var match$1 = alertJs.alertType;
  var match$2 = Belt_Option.flatMap(Caml_option.nullable_to_opt(alertJs.conversation), conversationFromJs);
  if ((match == null) || !(match === "new" && !((match$1 == null) || !(match$1 === "ConversationMessageNotification" && match$2 !== undefined)))) {
    return ;
  } else {
    return {
            id: alertJs.id,
            alertStatus: "NEW",
            alertType: "CONVERSATION_MESSAGE_NOTIFICATION",
            conversation: match$2
          };
  }
}

var make = ConversationAlertProvider;

var ConversationAlertsProvider = {
  make: make
};

function ConversationAlerts$ConversationAlertsUpdater(props) {
  var onNewAlerts = props.onNewAlerts;
  var alerts = props.alerts;
  var match = React.useState(function () {
        return {
                processedAlerts: Belt_List.fromArray(alerts)
              };
      });
  var setState = match[1];
  var state = match[0];
  React.useEffect((function () {
          var newAlerts = Belt_List.fromArray(Belt_Array.keep(alerts, (function (alert) {
                      return !Utils.List.any((function (oldAlert) {
                                    return alert.id === oldAlert.id;
                                  }), state.processedAlerts);
                    })));
          Curry._1(setState, (function (param) {
                  return {
                          processedAlerts: Belt_List.concat(state.processedAlerts, newAlerts)
                        };
                }));
          if (Belt_List.length(newAlerts) > 0) {
            Curry._1(onNewAlerts, newAlerts);
          }
          
        }), [alerts]);
  return null;
}

var ConversationAlertsUpdater = {
  make: ConversationAlerts$ConversationAlertsUpdater
};

function ConversationAlerts$Watcher(props) {
  var onNewAlerts = props.onNewAlerts;
  return React.createElement(make, {
              children: (function (alerts) {
                  return React.createElement(ConversationAlerts$ConversationAlertsUpdater, {
                              alerts: Belt_Array.keepMap(alerts, alertFromJs),
                              onNewAlerts: onNewAlerts
                            });
                })
            });
}

var Watcher = {
  make: ConversationAlerts$Watcher
};

function getNewConversationAlerts(alerts) {
  return Belt_List.keep(alerts, (function (alert) {
                return alert.conversation.message.messageType === "INITIAL";
              }));
}

function getNewMessageAlerts(alerts) {
  return Belt_List.keep(alerts, (function (alert) {
                return alert.conversation.message.messageType === "REPLY";
              }));
}

exports.messageFromJs = messageFromJs;
exports.conversationFromJs = conversationFromJs;
exports.alertFromJs = alertFromJs;
exports.ConversationAlertsProvider = ConversationAlertsProvider;
exports.ConversationAlertsUpdater = ConversationAlertsUpdater;
exports.Watcher = Watcher;
exports.getNewConversationAlerts = getNewConversationAlerts;
exports.getNewMessageAlerts = getNewMessageAlerts;
/* make Not a pure module */
